import { Inject, Injectable, Injector } from '@angular/core';

import { Ultraship_ReportService } from './Ultraship.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.Ultraship = this.injector.get(Ultraship_ReportService);
  }
    public Ultraship: Ultraship_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

